<template>
  <el-dialog
    :title="type === 'add'?$t('tian-jia-she-zhi'):$t('bian-ji-she-zhi')"
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="type === 'edit'"
    :modal-append-to-body='false'
    :before-close="clearForm">
    <el-form class="edit_form"
              :model="form"
              ref="form"
              :rules="formRules"
              :label-width="formLabelWidth">
      <el-col :span="24">
        <el-form-item :label="$t('yu-yue-ming-cheng')" prop="appointName">
          <el-input :style="{width: '80%'}"  v-model="form.appointName" autocomplete="off" maxlength="100" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('ti-qian-shi-jian-liang')" prop="appointTimes">
          <el-select :placeholder="$t('xuan-ze-ti-qian-shi-jian-liang')" v-model="form.appointTimes">
            <el-option v-for="item in appointTimesForSelect" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
          <!--<el-input v-model="form.appointTimes" autocomplete="off" show-word-limit>-->
            <!--<template slot="append">分</template>-->
          <!--</el-input>-->
        </el-form-item>
      </el-col>
      <!--<el-col :span="12">
        <el-form-item label="移动端显示可预约时间：" prop="typeModel">
          <el-switch v-model="form.showAppoint"></el-switch>
        </el-form-item>
      </el-col>-->
      <el-col :span="12">
        <el-form-item :label="$t('ke-yu-yue-yu-zhi')" prop="targetIntegral">
          <el-input :placeholder="$t('yu-yue-zui-di-fen-zhi')" v-model="form.targetIntegral" autocomplete="off">
            <template slot="append">{{ $t('ji-fen-1') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col class="el-row--flex" :span="12">
        <el-form-item :label="$t('dan-ci-yu-yue-xiao-hao-ji-fen')" prop="appointIsDeduct">
          <el-switch v-model="form.appointIsDeduct"></el-switch>
        </el-form-item>
        <el-form-item label-width="10px" prop="appointDeductIntegral" v-if="form.appointIsDeduct">
          <el-input v-model="form.appointDeductIntegral" :style="{width: '130px'}" autocomplete="off">
            <template slot="append">{{ $t('ji-fen-1') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('dang-yue-zui-da-qu-xiao-ci-shu')" prop="maxNum">
          <el-input :placeholder="$t('da-yu-0-sheng-xiao')" v-model="form.maxNum" autocomplete="off">
            <template slot="append">{{ $t('ci') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('shi-yue-kou-fen')" prop="deductIntegral">
          <el-input v-model="form.deductIntegral" autocomplete="off">
            <template slot="append">{{ $t('ji-fen-1') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('miao-shu')" prop="desc">
          <el-input type="textarea" :style="{width: '80%'}" v-model="form.desc" :autosize="{ minRows: 2, maxRows: 4 }" autocomplete="off" maxlength="255" show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('sheng-xiao-ri-qi')" prop="appointDate">
          <!--<el-input v-model="form.beginTime" autocomplete="off" show-word-limit></el-input>-->
          <el-date-picker
            v-model="form.appointDate"
            type="daterange"
            align="right"
            unlink-panels
            :range-separator="$t('zhi')"
            :start-placeholder="$t('kai-shi-ri-qi')"
            :end-placeholder="$t('jie-shu-ri-qi')"
            value-format="yyyy-MM-dd"
            :picker-options="dateOps"
            @input="updateAppointDate">
          </el-date-picker>
        </el-form-item>
      </el-col><el-col :span="12">
      <el-form-item :label="$t('shi-fou-qi-yong')" prop="state">
        <el-select :placeholder="$t('shi-fou-qi-yong-0')" v-model="form.state" >
          <el-option v-for="item in stateForSelect" :key="item.value"
                     v-bind:label="item.message" v-bind:value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('sheng-xiao-shi-jian-duan')" prop="timeSlots">
          <mul-time-picker ref="timeSlots-pick"
                           v-model="form.timeSlots"
                           :step="10"
                           @change="validate('timeSlots')"
            >
          </mul-time-picker>
        </el-form-item>
      </el-col>
      <!--<el-col :span="24">-->
        <!--<el-form-item label="预约费率：" :label-width="formLabelWidth" prop="typeModel">-->
          <!--<el-input v-model="form.typeModel" autocomplete="off" maxlength="30" show-word-limit></el-input>-->
        <!--</el-form-item>-->
      <!--</el-col>-->
      <el-col :span="12">
        <el-form-item :label="$t('yun-ying-shang')" prop="operatorId">
          <el-cascader  ref="cascader"
                        :placeholder="$t('xuan-ze-yun-ying-shang')"  filterable
                        :options="this.setTreeDisable(this.operatorTree)"
                        :props="{ checkStrictly:true,expandTrigger:'hover'}"
                        :show-all-levels="false"
                        change-on-select
                        @change='handleChangeStation'
                        v-model="form.operatorId">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('xuan-ze-ke-yu-yue-zhan')" prop="stationCode">
          <el-select :placeholder="$t('xuan-ze-ke-yu-yue-zhan-0')" ref="stationSelect" v-model="form.stationCode" @change="stationSelect">
            <el-option v-for="item in stationsForSelect" :key="item.stationCode"
                       v-bind:label="item.stationName" v-bind:value="item.stationCode"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('ke-yu-yue-qiang')" prop="typeModel" v-if="form.stationCode">
          <el-tree
            :data="gunTree"
            :default-checked-keys="form.gunTree"
            default-expand-all
            show-checkbox
            node-key="id"
            @check="gunCheck">
          </el-tree>
        </el-form-item>
      </el-col>
      <!--隐藏id-->
      <el-col :span="12">
        <el-form-item hidden label="id"  prop="id">
          <el-input v-model="form.id" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <!--footer -->
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" plain @click="clearForm">{{ $t('qu-xiao') }}</el-button>
      <el-button size="mini" plain type="primary" @click.native="submit" :loading="loading">{{ $t('ti-jiao') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import MulTimePicker from '@/components/mulTimePicker'
  import appointmentApi from '../../../api/appointmentApi'
  export default {
    name: "add",
    components: {
      MulTimePicker
    },
    data() {
      return {
        form: {},
        formRules: {
          appointName: [
            { required: true, message: this.$t('qing-tian-xie-yu-yue-ming-cheng'), trigger: 'change' }
          ],
          appointTimes: [
            { required: true, message: this.$t('qing-xuan-ze-ti-qian-shi-jian-liang'), trigger: 'change' }
          ],
          targetIntegral: [
            { required: true, message: this.$t('qing-tian-xie-yu-yue-suo-xu-ji-fen-yu-zhi'), trigger: 'change' }
          ],
          appointDeductIntegral: [
            { required: true, message: this.$t('qing-tian-xie-dan-ci-xiao-hao-ji-fen'), trigger: 'change' }
          ],
          maxNum: [
            { required: true, message: this.$t('qing-tian-xie-zui-da-shi-yue-ci-shu'), trigger: 'change' }
          ],
          deductIntegral: [
            { required: true, message: this.$t('qing-tian-xie-shi-yue-kou-fen-shu-zhi'), trigger: 'change' }
          ],
          appointDate: [
            { required: true, message: this.$t('qing-xuan-ze-ke-yu-yue-ri-qi'), trigger: 'change' }
          ],
          state: [
            { required: true, message: this.$t('qing-xuan-ze-shi-fou-qi-yong-gai-pei-zhi'), trigger: 'change' }
          ],
          /*timeSlots: [
            { required: true, message: '请添加可预约时间段', trigger: 'blur' }
          ],*/
          operatorId: [
            { required: true, message: this.$t('monitoringCenter.opsTreePlaceholder'), trigger: 'change' }
          ],
          stationCode: [
            { required: true, message: this.$t('qing-xuan-ze-ke-yu-yue-zhan'), trigger: 'blur' }
          ],
          // operatorId: [
          //   { required: true, message: '请勾选可预约枪', trigger: 'change' }
          // ],
        },
        formLabelWidth: '200px',
        dateOps: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24*60*60*1000
          },
          shortcuts: [{
            text: this.$t('wei-lai-yi-zhou'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: this.$t('wei-lai-yi-ge-yue'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: this.$t('wei-lai-san-ge-yue'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        appointTimesForSelect: [],
        stateForSelect: []
      }
    },
    props:{
      type: {
        type: String,
        default: 'add'
      },
      data: {
        type: Object,
        default() {
          return null
        }
      },
      visible: false,
      loading: false,
      operatorTree:{
        type: Array,
        required: true
      },
      stationsForSelect:{
        type: Array,
        required: true
      },
      gunTree: {
        type: Array,
        required: true
      },
    },
    created() {
      this.getEnumsForSelect()
      this.form = {...this.data}
      this.formatIn(this.data, this.form)
    },
    watch: {
      data(val) {
        this.form = {...val}
        this.formatIn(val, this.form)
      },
    },
    methods: {
      getEnumsForSelect(){
        appointmentApi.appointConfEnumsforSelect().then((res)=>{
          if (res.code === 0){
            console.log(res.data.appointTimeEnum)
            this.appointTimesForSelect = JSON.parse(res.data.appointTimeEnum)
            this.stateForSelect = JSON.parse(res.data.appointStateEnum)
          }
        })
      },
      isEmptyObj(obj) {
        for (let key in obj) {
          if ({}.hasOwnProperty.call(obj, key)) return false;
        }
        return true;
      },
      formatIn(val1, val2) {
        if(!val1 || this.isEmptyObj(val1)) return
        // val2 = {...val1}
        if(val1.showAppoint) {
          val2.showAppoint = val1.showAppoint.code === 'Y'
        }
        if(val1.state) {
          val2.state = val1.state.code
        }
        if(val1.appointIsDeduct) {
          val2.appointIsDeduct = val1.appointIsDeduct === 'Y'
        }
        this.$set(val2, 'appointDate', [val1.beginTime, val1.endTime])
        let gunTree = []
        val1.appointConfGuns.forEach((item, i) => {
          gunTree.push(item.gunCode)
        })
        val2.gunTree = gunTree
        console.log(val2)
      }, // 转入函数
      formatOut(val1) {
        if(!val1) return
        let val2 = {...val1}
        if(val1.showAppoint === true) {
          val2.showAppoint = 'Y'
        }else {
          val2.showAppoint = 'N'
        }
        if(val1.appointIsDeduct === true) {
          val2.appointIsDeduct = 'Y'
        }else {
          val2.appointIsDeduct = 'N'
        }
        val2.beginTime = val1.appointDate[0]
        val2.endTime = val1.appointDate[1]
        val2.stationId = this.stationsForSelect.filter((item, i) => {
          return item.stationCode === val1.stationCode
        })[0].id
        // val1.state = '1'
        return val2
      }, // 转出函数
      updateAppointDate(e) {
        console.log(e)
        if(e) {
          this.$nextTick(() => {
            this.form.appointDate = null
            this.$set(this.form, 'appointDate', [e[0], e[1]])
          })
        }
      },// 没有监听到，使用$set来设置数据
      //对数据进行授权过滤
      setTreeDisable(val) {
        //对 treeList 进行递归操作，禁止选中unchecked和unapproved
        val && val.forEach(item => {
          if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
        return val;
      },
      handleChangeStation(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.form.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
      clearForm() {
        let _this = this
        if (this.type === 'add') {
          this.$confirm(this.$t('paramMonitor.message18')).then(_ => {
            _this.$refs.form.clearValidate()
            _this.$emit('close', _this.type)
          }).catch(_ => {
          })
        } else {
          _this.$refs.form.clearValidate()
          _this.$emit('close', _this.type)
        }
      },
      stationSelect(val){
        console.log(val)
        this.$emit("stationSelect", val)
      },
      gunCheck(data, checkedData) {
        console.log("gunCheck")
        // console.log(checkedData.checkedNodes)
        let gunTree = []
        checkedData.checkedNodes.forEach((item, i) => {
          if(!item.children){
            gunTree.push(item.id)
          }
        })
        this.form.gunTree = gunTree
      },
      validate(field) {
        console.log("validate:"+field)
        this.$refs.form.validateField(field)
      },
      submit() {
        // console.log(this.form)
        this.$refs.form.validate((valid) => {
          if (!valid) {
            return;
          }
          this.$emit("submit", this.formatOut(this.form))
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .edit_form {
    .el-form-item__content {
      .el-input {
        width: 180px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/appointmentManager/appointmentSettings/add.vue